export const navbar = [
	{
		id: 1,
		title: "About",
	},
	{
		id: 2,
		title: "Services",
	},
	{
		id: 3,
		title: "Projects",
	},
]
